<template>
  <div class="agent-tree-container">
    <!-- 面包屑导航 -->
    <el-breadcrumb separator="/" style="padding: 10px; font-size: 12px">
      <el-breadcrumb-item :to="{ path: '/home' }">首页</el-breadcrumb-item>
      <el-breadcrumb-item>代理管理</el-breadcrumb-item>
      <el-breadcrumb-item>代理学员树形列表</el-breadcrumb-item>
    </el-breadcrumb>

    <!-- 卡片容器 -->
    <el-card class="box-card" shadow="hover">
      <!-- 搜索表单 -->
      <el-form
        :inline="true"
        :model="searchForm"
        label-width="70px"
        class="search-form"
      >
        <el-form-item label="手机号">
          <el-input
            v-model="searchForm.phone"
            placeholder="请输入代理手机号"
            clearable
            @clear="handleSearch"
            @keyup.enter.native="handleSearch"
            max-length="11"
          ></el-input>
        </el-form-item>
        <el-form-item label="昵称">
          <el-input
            v-model="searchForm.nickName"
            placeholder="请输入代理昵称"
            clearable
            @clear="handleSearch"
            max-length="50"
          ></el-input>
        </el-form-item>
        <el-form-item>
          <el-button type="primary" icon="el-icon-search" @click="handleSearch"
            >查询</el-button
          >
          <el-button icon="el-icon-refresh" @click="handleReset"
            >重置</el-button
          >
        </el-form-item>
      </el-form>

      <!-- 树形表格（核心组件） -->
      <el-table
        v-loading="tableLoading"
        :data="treeData"
        border
        style="width: 100%"
        height="550"
        :tree-props="{ children: 'children', hasChildren: 'hasChildren' }"
        @expand-change="handleExpandChange"
        row-key="id"
      >
        <!-- 头像+基础信息列 -->
        <el-table-column label="代理/学员信息" width="450">
          <template slot-scope="scope">
            <div class="info-wrap">
              <!-- 头像 -->
              <el-image
                :src="scope.row.avatar || defaultAvatar"
                fit="cover"
                width="42"
                height="42"
                class="avatar"
                preview-src-list="[scope.row.avatar || defaultAvatar]"
              ></el-image>
              <!-- 信息容器 -->
              <div class="info-content">
                <div class="name-row">
                  <span class="nickname">{{
                    scope.row.nickName || "未设置昵称"
                  }}</span>
                  <!-- 身份标签 -->
                  <el-tag
                    size="mini"
                    type="primary"
                    v-if="scope.row.isAgent"
                    class="agent-tag"
                  >
                    代理
                  </el-tag>
                  <el-tag size="mini" type="info" v-else class="student-tag">
                    学员
                  </el-tag>
                </div>
                <div class="detail-row">
                  <span>ID: {{ scope.row.id }}</span>
                  <span class="phone-span">手机号: {{ scope.row.phone }}</span>
                </div>
              </div>
            </div>
          </template>
        </el-table-column>

        <!-- 注册时间 -->
        <el-table-column label="注册时间" width="180">
          <template slot-scope="scope">
            {{
              scope.row.createTime
                ? $moment(scope.row.createTime).format("YYYY-MM-DD HH:mm:ss")
                : "-"
            }}
          </template>
        </el-table-column>

        <!-- 学员总数（仅代理显示） -->
        <el-table-column label="学员总数" width="110" align="center">
          <template slot-scope="scope">
            <span v-if="scope.row.isAgent" class="student-count">
              {{ scope.row.studentCount || 0 }}
            </span>
            <span v-else>-</span>
          </template>
        </el-table-column>

        <!-- 下单状态 -->
        <el-table-column label="是否下单" width="120" align="center">
          <template slot-scope="scope">
            <el-tag
              size="mini"
              type="success"
              v-if="scope.row.hasOrder"
              class="order-tag"
            >
              已下单
            </el-tag>
            <el-tag size="mini" type="info" v-else class="no-order-tag">
              未下单
            </el-tag>
          </template>
        </el-table-column>

        <!-- 操作列 -->
        <el-table-column label="操作" width="200" align="center">
          <template slot-scope="scope">
            <!-- 代理：刷新学员 -->
            <el-button
              size="mini"
              type="text"
              icon="el-icon-refresh"
              @click.stop="handleRefreshStudents(scope.row)"
              v-if="scope.row.isAgent"
              class="refresh-btn"
            >
              刷新学员
            </el-button>

            <!-- 学员：查看订单 -->
            <el-button
              size="mini"
              type="primary"
              icon="el-icon-order"
              @click.stop="handleViewOrder(scope.row.id)"
              v-else
              v-hasPermission="'agent:viewOrder'"
              class="view-order-btn"
            >
              查看订单
            </el-button>
          </template>
        </el-table-column>
      </el-table>

      <!-- 代理分页组件 -->
      <el-pagination
        style="margin-top: 15px; text-align: right"
        background
        @size-change="handleAgentSizeChange"
        @current-change="handleAgentCurrentChange"
        :current-page="searchForm.pageNum"
        :page-sizes="[10, 20, 30, 50]"
        :page-size="searchForm.pageSize"
        layout="total, sizes, prev, pager, next, jumper"
        :total="total"
      ></el-pagination>
    </el-card>
  </div>
</template>

<script>
export default {
  name: "AgentTreeList",
  data() {
    return {
      // 表格加载状态
      tableLoading: false,
      // 学员加载状态（按代理ID存储，避免全局加载）
      studentLoading: {},
      // 树形表格数据
      treeData: [],
      // 代理总数
      total: 0,
      // 默认头像
      defaultAvatar:
        "https://cube.elemecdn.com/3/7c/3f7071cf9287870e355e3be67c110jpeg.jpeg",
      // 搜索表单
      searchForm: {
        pageNum: 1,
        pageSize: 20,
        phone: "",
        nickName: "",
      },
    };
  },

  created() {
    // 初始化加载代理列表
    this.loadAgentTreeList();
  },

  methods: {
    /**
     * 加载代理树形列表（顶级节点）
     */
    async loadAgentTreeList() {
      this.tableLoading = true;
      try {
        const { data: res } = await this.$http.get("/agent/tree-list", {
          params: this.searchForm,
        });
        if (res.code !== 200) {
          this.$message.error("加载代理列表失败：" + res.msg);
          return;
        }
        this.treeData = res.data.rows;
        this.total = res.data.total;
      } catch (error) {
        log.error("加载代理列表异常：", error);
        this.$message.error("加载代理列表异常，请联系管理员");
      } finally {
        this.tableLoading = false;
      }
    },

    /**
     * 展开/折叠代理节点：懒加载学员
     */
    async handleExpandChange(row, expandedRows) {
      if (!row.isAgent) return; // 非代理节点不处理

      // 展开节点：加载学员
      if (expandedRows.includes(row)) {
        this.studentLoading[row.id] = true; // 标记该代理的学员加载中

        try {
          const { data: res } = await this.$http.get("/agent/load-students", {
            params: {
              agentId: row.id,
              pageNum: 1,
              pageSize: this.searchForm.pageSize,
            },
          });

          if (res.code === 200) {
            // 给当前代理设置学员列表
            row.children = res.data.rows;
            // 学员总数已在代理节点中查询，无需重复设置
          } else {
            this.$message.error("加载学员失败：" + res.msg);
          }
        } catch (error) {
          log.error("加载学员异常：", error);
          this.$message.error("加载学员异常，请联系管理员");
        } finally {
          this.studentLoading[row.id] = false;
        }
      } else {
        // 折叠节点：清空学员列表（保留hasChildren标记，下次可重新加载）
        row.children = null;
      }
    },

    /**
     * 刷新代理的学员列表
     */
    async handleRefreshStudents(agentRow) {
      if (!agentRow.isAgent) return;

      this.studentLoading[agentRow.id] = true;
      try {
        const { data: res } = await this.$http.get("/agent/load-students", {
          params: {
            agentId: agentRow.id,
            pageNum: 1,
            pageSize: this.searchForm.pageSize,
          },
        });

        if (res.code === 200) {
          agentRow.children = res.data.rows;
          this.$message.success("学员列表已刷新");
        } else {
          this.$message.error("刷新学员失败：" + res.msg);
        }
      } catch (error) {
        log.error("刷新学员异常：", error);
        this.$message.error("刷新学员异常，请联系管理员");
      } finally {
        this.studentLoading[agentRow.id] = false;
      }
    },

    /**
     * 查看学员订单（跳转至订单列表，筛选该学员）
     */
    handleViewOrder(studentId) {
      this.$router.push({
        path: "/order/list", // 你的订单列表页面路径
        query: { userId: studentId }, // 携带学员ID筛选订单
      });
    },

    /**
     * 搜索代理
     */
    handleSearch() {
      this.searchForm.pageNum = 1; // 重置为第一页
      this.loadAgentTreeList();
    },

    /**
     * 重置搜索表单
     */
    handleReset() {
      this.searchForm = {
        pageNum: 1,
        pageSize: 20,
        phone: "",
        nickName: "",
      };
      this.loadAgentTreeList();
    },

    /**
     * 代理分页大小改变
     */
    handleAgentSizeChange(newSize) {
      this.searchForm.pageSize = newSize;
      this.loadAgentTreeList();
    },

    /**
     * 代理当前页改变
     */
    handleAgentCurrentChange(currentPage) {
      this.searchForm.pageNum = currentPage;
      this.loadAgentTreeList();
    },
  },
};
</script>

<style scoped>
.agent-tree-container {
  padding: 0 15px 15px;
}

/* 搜索表单样式 */
.search-form {
  margin-bottom: 15px;
}

/* 信息容器样式 */
.info-wrap {
  display: flex;
  align-items: center;
  width: 100%;
}

/* 头像样式 */
.avatar {
  border-radius: 50%;
  border: 1px solid #e8f4f8;
  cursor: pointer;
  transition: border-color 0.3s;
}
.avatar:hover {
  border-color: #409eff;
}

/* 信息内容样式 */
.info-content {
  margin-left: 12px;
  flex: 1;
  overflow: hidden;
}

.name-row {
  display: flex;
  align-items: center;
  margin-bottom: 4px;
}

.nickname {
  font-size: 14px;
  font-weight: 500;
  color: #333;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
  max-width: 200px;
}

/* 身份标签样式 */
.agent-tag {
  margin-left: 8px;
  background-color: #409eff !important;
}
.student-tag {
  margin-left: 8px;
  background-color: #909399 !important;
}

/* 详情行样式 */
.detail-row {
  font-size: 12px;
  color: #666;
}

.phone-span {
  margin-left: 15px;
}

/* 学员总数样式 */
.student-count {
  color: #409eff;
  font-weight: 500;
  font-size: 14px;
}

/* 订单标签样式 */
.order-tag {
  background-color: #67c23a !important;
}
.no-order-tag {
  background-color: #909399 !important;
}

/* 按钮样式 */
.refresh-btn {
  color: #409eff;
  padding: 0;
}
.refresh-btn:hover {
  color: #66b1ff;
}

.view-order-btn {
  padding: 4px 10px;
}

/* 表格行悬停样式 */
.el-table__row:hover {
  background-color: #f5fafe !important;
}

/* 加载状态样式 */
.el-table__loading {
  z-index: 10;
}
</style>
